import TelephoneConfigurationView from './TelephoneConfigurationView'

export default TelephoneConfigurationView
